// import React, { useState } from 'react';
// import styles from './style.module.css';
// import Typography from '../Typography/Typography';
// import FlatButtons from '../FlatButton/FlatButton';

// interface NotificationItem {
//     id: string;
//     type: 'order' | 'rating' | 'general';
//     title: string;
//     message: string;
//     time: string;
//     isRead: boolean;
//     emoji?: string;
// }

// interface NotificationModalProps {
//     isOpen: boolean;
//     onClose: () => void;
//     notifications?: NotificationItem[];
//     onMarkAllAsRead?: () => void;
//     onMarkAsRead?: (id: string) => void;
// }

// const defaultNotifications: NotificationItem[] = [
//     {
//         id: '1',
//         type: 'order',
//         title: 'New order just dropped',
//         message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
//         time: '10:00pm',
//         isRead: false,
//         emoji: '🎉'
//     },
//     {
//         id: '2',
//         type: 'rating',
//         title: 'You just received a new rating from a customer',
//         message: 'A recent customer just add a review to your store "The store sells really good product...',
//         time: '10:00pm',
//         isRead: false
//     },
//     {
//         id: '3',
//         type: 'order',
//         title: 'New order just dropped',
//         message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
//         time: '10:00pm',
//         isRead: false,
//         emoji: '🎉'
//     },
//     {
//         id: '4',
//         type: 'order',
//         title: 'New order just dropped',
//         message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
//         time: '10:00pm',
//         isRead: false,
//         emoji: '🎉'
//     },
//     {
//         id: '5',
//         type: 'order',
//         title: 'New Order just dropped',
//         message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
//         time: '10:00pm',
//         isRead: true,
//         emoji: '🎉'
//     }
// ];

// export const NotificationModal: React.FC<NotificationModalProps> = ({
//     isOpen,
//     onClose,
//     notifications = defaultNotifications,
//     onMarkAllAsRead,
//     onMarkAsRead
// }) => {
//     const [notificationList, setNotificationList] = useState<NotificationItem[]>(notifications);

//     if (!isOpen) return null;

//     const handleMarkAllAsRead = () => {
//         if (onMarkAllAsRead) {
//             onMarkAllAsRead();
//         } else {
//             setNotificationList(prev => 
//                 prev.map(notification => ({ ...notification, isRead: true }))
//             );
//         }
//     };

//     const handleMarkAsRead = (id: string) => {
//         if (onMarkAsRead) {
//             onMarkAsRead(id);
//         } else {
//             setNotificationList(prev => 
//                 prev.map(notification => 
//                     notification.id === id 
//                         ? { ...notification, isRead: true }
//                         : notification
//                 )
//             );
//         }
//     };

//     const handleNotificationClick = (notification: NotificationItem) => {
//         if (!notification.isRead) {
//             handleMarkAsRead(notification.id);
//         }
//     };

//     const handleOverlayClick = (e: React.MouseEvent) => {
//         if (e.target === e.currentTarget) {
//             onClose();
//         }
//     };

//     return (
//         <div className={styles.overlay} onClick={handleOverlayClick}>
//             <div className={styles.modal}>
//                 <div className={styles.header}>
//                     <Typography
//                         variant="heading4"
//                         fontFamily="satoshi"
//                         weight="bold"
//                         size='base'
//                         className={styles.headerTitle}
//                     >
//                         Notification
//                     </Typography>
//                     <FlatButtons
//                         className={styles.markAllButton}
//                         onClick={handleMarkAllAsRead}
//                     >
//                         <Typography
//                             variant="heading4"
//                             fontFamily="satoshi"
//                             weight="bold"
//                             className={styles.markAllText}
//                         >
//                             Mark all as read
//                         </Typography>
//                     </FlatButtons>
//                 </div>

//                 <div className={styles.content}>
//                     {notificationList.map((notification) => (
//                         <div
//                             key={notification.id}
//                             className={`${styles.notificationItem} ${
//                                 notification.isRead ? styles.read : styles.unread
//                             }`}
//                             onClick={() => handleNotificationClick(notification)}
//                         >
//                             <div className={styles.notificationContent}>
//                                 <div className={styles.titleRow}>
//                                     <Typography
//                                         variant="heading4"
//                                         fontFamily="satoshi"
//                                         weight="bold"
//                                         className={styles.notificationTitle}
//                                     >
//                                         {notification.title}
//                                         {notification.emoji && (
//                                             <span className={styles.emoji}>
//                                                 {notification.emoji}
//                                             </span>
//                                         )}
//                                     </Typography>
//                                     {!notification.isRead && (
//                                         <div className={styles.unreadDot}></div>
//                                     )}
//                                 </div>
//                                 <Typography
//                                     variant="bodyRegular"
//                                     fontFamily="satoshi"
//                                     weight="regular"
//                                     className={styles.notificationMessage}
//                                 >
//                                     {notification.message}
//                                 </Typography>
//                                 <Typography
//                                     variant="bodyRegular"
//                                     fontFamily="satoshi"
//                                     weight="regular"
//                                     className={styles.notificationTime}
//                                 >
//                                     {notification.time}
//                                 </Typography>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };


import React, { useState, useEffect } from 'react';
import styles from './style.module.css';
import Typography from '../Typography/Typography';
import FlatButtons from '../FlatButton/FlatButton';

interface NotificationItem {
    id: string;
    type: 'order' | 'rating' | 'general';
    title: string;
    message: string;
    time: string;
    isRead: boolean;
    emoji?: string;
}

interface NotificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    notifications?: NotificationItem[];
    onMarkAllAsRead?: () => void;
    onMarkAsRead?: (id: string) => void;
}

const defaultNotifications: NotificationItem[] = [
    {
        id: '1',
        type: 'order',
        title: 'New order just dropped',
        message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
        time: '10:00pm',
        isRead: false,
        emoji: '🎉'
    },
    {
        id: '2',
        type: 'rating',
        title: 'You just received a new rating from a customer',
        message: 'A recent customer just add a review to your store "The store sells really good product...',
        time: '10:00pm',
        isRead: false
    },
    {
        id: '3',
        type: 'order',
        title: 'New order just dropped',
        message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
        time: '10:00pm',
        isRead: false,
        emoji: '🎉'
    },
    {
        id: '4',
        type: 'order',
        title: 'New order just dropped',
        message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
        time: '10:00pm',
        isRead: false,
        emoji: '🎉'
    },
    {
        id: '5',
        type: 'order',
        title: 'New Order just dropped',
        message: 'Order Info: Customer; Joseph Wheeler, Items; 2, Amount; $200...',
        time: '10:00pm',
        isRead: true,
        emoji: '🎉'
    }
];

export const NotificationModal: React.FC<NotificationModalProps> = ({
    isOpen,
    onClose,
    notifications = defaultNotifications,
    onMarkAllAsRead,
    onMarkAsRead
}) => {
    const [notificationList, setNotificationList] = useState<NotificationItem[]>(notifications);

    // Close modal on Escape key press
    useEffect(() => {
        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleMarkAllAsRead = () => {
        if (onMarkAllAsRead) {
            onMarkAllAsRead();
        } else {
            setNotificationList(prev => 
                prev.map(notification => ({ ...notification, isRead: true }))
            );
        }
    };

    const handleMarkAsRead = (id: string) => {
        if (onMarkAsRead) {
            onMarkAsRead(id);
        } else {
            setNotificationList(prev => 
                prev.map(notification => 
                    notification.id === id 
                        ? { ...notification, isRead: true }
                        : notification
                )
            );
        }
    };

    const handleNotificationClick = (notification: NotificationItem) => {
        if (!notification.isRead) {
            handleMarkAsRead(notification.id);
        }
    };

    const handleOverlayClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className={styles.overlay} onClick={handleOverlayClick}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <Typography
                        variant="heading4"
                        fontFamily="satoshi"
                        weight="bold"
                        size='base'
                        className={styles.headerTitle}
                    >
                        Notification
                    </Typography>
                    <FlatButtons
                        className={styles.markAllButton}
                        onClick={handleMarkAllAsRead}
                    >
                        <Typography
                            variant="heading4"
                            fontFamily="satoshi"
                            weight="bold"
                            className={styles.markAllText}
                        >
                            Mark all as read
                        </Typography>
                    </FlatButtons>
                </div>

                <div className={styles.content}>
                    {notificationList.map((notification) => (
                        <div
                            key={notification.id}
                            className={`${styles.notificationItem} ${
                                notification.isRead ? styles.read : styles.unread
                            }`}
                            onClick={() => handleNotificationClick(notification)}
                        >
                            <div className={styles.notificationContent}>
                                <div className={styles.titleRow}>
                                    <Typography
                                        variant="heading4"
                                        fontFamily="satoshi"
                                        weight="bold"
                                        className={styles.notificationTitle}
                                    >
                                        {notification.title}
                                        {notification.emoji && (
                                            <span className={styles.emoji}>
                                                {notification.emoji}
                                            </span>
                                        )}
                                    </Typography>
                                    {!notification.isRead && (
                                        <div className={styles.unreadDot}></div>
                                    )}
                                </div>
                                <Typography
                                    variant="bodyRegular"
                                    fontFamily="satoshi"
                                    weight="regular"
                                    className={styles.notificationMessage}
                                >
                                    {notification.message}
                                </Typography>
                                <Typography
                                    variant="bodyRegular"
                                    fontFamily="satoshi"
                                    weight="regular"
                                    className={styles.notificationTime}
                                >
                                    {notification.time}
                                </Typography>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};